// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/img2/pay_top_main_bg.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/img2/pay_top_title_select.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.slSYbgCh {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  overflow: visible;
  background-color: transparent;
}
.slSYbgCh::before,
.slSYbgCh::after {
  content: '';
  position: absolute;
  top: 0;
  pointer-events: none;
}
.slSYbgCh::before {
  left: 0;
  z-index: 0;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) left top / auto 100% no-repeat;
}
.slSYbgCh::after {
  right: 0;
  z-index: 1;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat;
  background-size: calc(100% / (1 - 0.8)) 100%;
  background-position: right top;
}
@media (max-width: 767px) {
  .slSYbgCh {
    height: auto;
    min-height: 3.125rem;
    padding: 0.5rem 0;
    overflow: hidden;
  }
  .slSYbgCh::before {
    height: calc(3.125rem * 110 / 104);
    width: calc(3.125rem * 328 / 104 + 2px);
  }
  .slSYbgCh::after {
    left: calc(3.125rem * 328 / 104 - 2px);
    height: 3.125rem;
  }
}
@media (min-width: 768px) and (max-width: 1023px) {
  .slSYbgCh {
    display: -webkit-box;
    display: -webkit-flex;
    display: flex;
    -webkit-box-align: center;
    -webkit-align-items: center;
            align-items: center;
    height: 5rem;
  }
  .slSYbgCh::before {
    height: calc(5rem * 110 / 104);
    width: calc(5rem * 328 / 104 + 2px);
  }
  .slSYbgCh::after {
    left: calc(5rem * 328 / 104 - 2px);
    height: 5.3rem;
  }
}
@media (min-width: 1024px) {
  .slSYbgCh {
    display: -webkit-box;
    display: -webkit-flex;
    display: flex;
    -webkit-box-align: center;
    -webkit-align-items: center;
            align-items: center;
    height: 5rem;
  }
  .slSYbgCh::before {
    height: calc(5rem * 110 / 104);
    width: calc(5rem * 328 / 104 + 2px);
  }
  .slSYbgCh::after {
    left: calc(5rem * 328 / 104 - 2px);
    height: 5.3rem;
  }
}
.VjeZst5L {
  position: relative;
  background: #f5f5f5;
  padding: 0.5rem;
  padding-top: 4.375rem;
}
@media (min-width: 768px) and (max-width: 1023px) {
  .VjeZst5L {
    display: none;
  }
}
@media (min-width: 768px) {
  .VjeZst5L.z8MR9HQQ {
    display: none;
  }
}
@media (min-width: 768px) {
  .VjeZst5L.dG2Qxs0k {
    display: none;
  }
}
@media (max-width: 767px) {
  .VjeZst5L.a_eZ1XUE {
    display: none;
  }
}
@media (max-width: 767px) {
  .VjeZst5L.yb7OA2X7 {
    display: none;
  }
}
@media (min-width: 1024px) {
  .VjeZst5L {
    position: absolute;
    top: 14vw;
    left: 1%;
    z-index: 999;
    width: 98%;
    margin: 0 auto;
    border-radius: 1rem;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
    display: -webkit-box;
    display: -webkit-flex;
    display: flex;
    -webkit-box-align: center;
    -webkit-align-items: center;
            align-items: center;
    padding: 0 2rem;
    padding-top: 0;
    height: 7rem;
  }
}
.BtEycIWT {
  width: 100%;
}
.Y4OQJmfp {
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-pack: start;
  -webkit-justify-content: flex-start;
          justify-content: flex-start;
  -webkit-box-align: center;
  -webkit-align-items: center;
          align-items: center;
  gap: 0.5rem;
  cursor: pointer;
}
@media (max-width: 767px) {
  .Y4OQJmfp {
    gap: 0.5rem;
  }
}
.zHIhM57O {
  width: 3rem;
  height: 3rem;
  border-radius: 0.5rem;
  -webkit-flex-shrink: 0;
          flex-shrink: 0;
  position: relative;
  overflow: hidden;
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
          align-items: center;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
          justify-content: center;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}
@media (max-width: 767px) {
  .zHIhM57O {
    width: 3rem;
    height: 3rem;
  }
}
@media (min-width: 1024px) {
  .zHIhM57O {
    width: 5rem;
    height: 5rem;
    border-radius: 1rem;
  }
}
.OTNvIQ1p {
  width: 100%;
  height: 100%;
  -o-object-fit: cover;
     object-fit: cover;
  border-radius: 0.5rem;
}
.GDmL5IO3 {
  width: 100%;
  height: 100%;
}
.sVB5c3uo {
  -webkit-box-flex: 1;
  -webkit-flex: 1;
          flex: 1;
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-direction: column;
          flex-direction: column;
  gap: 0.25rem;
  font-size: 0.75rem;
}
.WfBlVulO {
  display: none;
}
@media (min-width: 1024px) {
  .WfBlVulO {
    display: block;
    font-size: 1rem;
    font-weight: 500;
    color: #585858;
    margin-bottom: 0.25rem;
  }
}
.qN8X9qUM {
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-pack: start;
  -webkit-justify-content: flex-start;
          justify-content: flex-start;
  -webkit-box-align: center;
  -webkit-align-items: center;
          align-items: center;
  gap: 0.25rem;
  width: 100%;
}
.o75QkgKG {
  color: #585858;
  font-size: 0.875rem;
}
@media (max-width: 767px) {
  .o75QkgKG {
    font-size: 0.4625rem;
  }
}
.d5JyeBW_ {
  color: #1890ff;
  font-size: 0.875rem;
  cursor: pointer;
  -webkit-transition: opacity 0.2s ease;
  transition: opacity 0.2s ease;
}
.d5JyeBW_:hover {
  opacity: 0.8;
}
.d5JyeBW_:active {
  opacity: 0.6;
}
@media (max-width: 767px) {
  .d5JyeBW_ {
    font-size: 0.75rem;
  }
}
.p7ZdYuU7 {
  display: inline-block;
  width: auto;
  height: 1em;
  vertical-align: middle;
  margin-left: 0.25rem;
  cursor: pointer;
  -webkit-transition: opacity 0.2s ease;
  transition: opacity 0.2s ease;
}
.p7ZdYuU7:hover {
  opacity: 0.8;
}
.p7ZdYuU7:active {
  opacity: 0.6;
}
@media (max-width: 767px) {
  .p7ZdYuU7 {
    height: 1rem;
    margin-left: 0.25rem;
  }
}
.iJmvZ14p {
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-pack: start;
  -webkit-justify-content: flex-start;
          justify-content: flex-start;
  -webkit-box-align: center;
  -webkit-align-items: center;
          align-items: center;
  gap: 0.25rem;
  -webkit-flex-wrap: wrap;
          flex-wrap: wrap;
  font-size: 0.875rem;
}
.SGn_HB4s {
  color: #1890ff;
  cursor: pointer;
  -webkit-transition: color 0.2s ease;
  transition: color 0.2s ease;
}
.SGn_HB4s:hover {
  color: #0076e4;
}
.GwNgdG1L {
  color: #666666;
  font-size: 0.875rem;
}
@media (max-width: 767px) {
  .GwNgdG1L {
    font-size: 0.875rem;
  }
}
.sLKWM0Wj {
  background: none;
  padding: 0;
  margin: 0;
  outline: none;
  font-family: inherit;
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
          align-items: center;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
          justify-content: center;
  padding: 0.125rem 0.25rem;
  background: transparent;
  border: none;
  color: #1890ff;
  cursor: pointer;
  -webkit-transition: opacity 0.2s ease;
  transition: opacity 0.2s ease;
}
.sLKWM0Wj:hover {
  opacity: 0.8;
}
.sLKWM0Wj:active {
  opacity: 0.6;
}
@media (max-width: 767px) {
  .sLKWM0Wj {
    padding: 0.0625rem 0.25rem;
  }
}
.UA1ikLgE {
  position: relative;
  z-index: 2;
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
          align-items: center;
  margin: 0 auto;
  gap: 1.5rem;
}
@media (max-width: 767px) {
  .UA1ikLgE {
    padding: 0 0.5rem;
    -webkit-box-pack: justify;
    -webkit-justify-content: space-between;
            justify-content: space-between;
  }
}
@media (min-width: 768px) and (max-width: 1023px) {
  .UA1ikLgE {
    padding: 1rem 1.25rem;
    -webkit-box-pack: justify;
    -webkit-justify-content: space-between;
            justify-content: space-between;
    width: 100%;
    box-sizing: border-box;
  }
}
@media (min-width: 1024px) {
  .UA1ikLgE {
    -webkit-box-pack: justify;
    -webkit-justify-content: space-between;
            justify-content: space-between;
    padding: 1.5rem 1rem;
    width: 100%;
  }
}
._fyIi7KJ {
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-pack: start;
  -webkit-justify-content: flex-start;
          justify-content: flex-start;
  -webkit-box-align: center;
  -webkit-align-items: center;
          align-items: center;
  -webkit-flex-shrink: 0;
          flex-shrink: 0;
}
.sbCrta3X {
  text-decoration: none;
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
          align-items: center;
  gap: 0.25rem;
}
@media (min-width: 1024px) {
  .sbCrta3X {
    gap: 0.5rem;
  }
}
.bPFeSkuu {
  height: 2.25rem;
  width: auto;
  -o-object-fit: contain;
     object-fit: contain;
  display: block;
  -webkit-flex-shrink: 0;
          flex-shrink: 0;
}
@media (max-width: 767px) {
  .bPFeSkuu {
    height: 1.875rem;
  }
}
@media (min-width: 768px) and (max-width: 1023px) {
  .bPFeSkuu {
    height: 2.25rem;
  }
}
@media (min-width: 1024px) {
  .bPFeSkuu {
    height: 4rem;
  }
}
.aYCUJo6Z {
  height: 1.5rem;
  width: auto;
  max-width: 100%;
  -o-object-fit: contain;
     object-fit: contain;
  display: block;
  -webkit-flex-shrink: 0;
          flex-shrink: 0;
}
@media (max-width: 767px) {
  .aYCUJo6Z {
    width: auto;
    max-width: 100%;
    height: auto;
    max-height: 1rem;
    -webkit-align-self: flex-start;
            align-self: flex-start;
  }
}
@media (min-width: 768px) and (max-width: 1023px) {
  .aYCUJo6Z {
    width: auto;
    max-width: 100%;
    height: auto;
    max-height: 1.25rem;
    -webkit-align-self: flex-start;
            align-self: flex-start;
  }
}
@media (min-width: 1024px) {
  .aYCUJo6Z {
    width: auto;
    height: 2rem;
    max-height: none;
    margin-top: 0;
    -webkit-align-self: center;
            align-self: center;
  }
}
.YEXthgKT {
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
          align-items: center;
  -webkit-box-pack: start;
  -webkit-justify-content: flex-start;
          justify-content: flex-start;
  gap: 1.5rem;
}
@media (max-width: 1023px) {
  .YEXthgKT {
    position: fixed;
    top: 3.75rem;
    left: 0;
    right: 0;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -webkit-flex-direction: column;
            flex-direction: column;
    background: #ffffff;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
    -webkit-transform: translateX(-100%);
            transform: translateX(-100%);
    -webkit-transition: -webkit-transform 0.3s ease;
    transition: -webkit-transform 0.3s ease;
    transition: transform 0.3s ease;
    transition: transform 0.3s ease, -webkit-transform 0.3s ease;
    gap: 0;
    z-index: 1000;
    padding: 0.25rem 0;
  }
  .YEXthgKT.Mg_ORDaH {
    -webkit-transform: translateX(0);
            transform: translateX(0);
  }
}
@media (min-width: 1024px) {
  .YEXthgKT {
    display: none;
  }
}
.NRbCIQNp {
  color: #585858;
  text-decoration: none;
  font-size: 1rem;
  font-family: 'JingNan BoBo Hei', 'Source Han Sans SC', 'PingFang SC', 'Microsoft YaHei', sans-serif;
  -webkit-transition: color 0.3s ease;
  transition: color 0.3s ease;
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-pack: start;
  -webkit-justify-content: flex-start;
          justify-content: flex-start;
  -webkit-box-align: center;
  -webkit-align-items: center;
          align-items: center;
  gap: 0.5rem;
  background: none;
  border: none;
  cursor: pointer;
  font-family: inherit;
  padding: 0;
}
.NRbCIQNp:hover {
  color: #1890ff;
}
@media (max-width: 767px) {
  .NRbCIQNp {
    text-align: center;
    margin: 0 auto;
    border-bottom: 1px solid #e8e8e8;
    width: 70%;
    padding: 1rem 1.5rem;
    min-height: 2.75rem;
    min-width: 2.75rem;
    display: -webkit-box;
    display: -webkit-flex;
    display: flex;
    -webkit-box-pack: center;
    -webkit-justify-content: center;
            justify-content: center;
    -webkit-box-align: center;
    -webkit-align-items: center;
            align-items: center;
    font-size: 0.875rem;
    gap: 1rem;
  }
}
@media (min-width: 768px) and (max-width: 1023px) {
  .NRbCIQNp {
    text-align: center;
    margin: 0 auto;
    border-bottom: 1px solid #e8e8e8;
    width: 70%;
    padding: 1rem 1.5rem;
    min-height: 2.75rem;
    min-width: 2.75rem;
    display: -webkit-box;
    display: -webkit-flex;
    display: flex;
    -webkit-box-pack: center;
    -webkit-justify-content: center;
            justify-content: center;
    -webkit-box-align: center;
    -webkit-align-items: center;
            align-items: center;
    font-size: 0.875rem;
    gap: 1rem;
  }
}
.NRbCIQNp:last-child {
  border-bottom: none;
}
.o_dTFhV5 {
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
          align-items: center;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
          justify-content: center;
  -webkit-flex-shrink: 0;
          flex-shrink: 0;
  width: 1.25rem;
  height: 1.25rem;
  color: inherit;
}
@media (max-width: 767px) {
  .o_dTFhV5 {
    width: 1.25rem;
    height: 1.25rem;
  }
}
.s4NCMenQ {
  -webkit-box-flex: 0;
  -webkit-flex: 0 0 auto;
          flex: 0 0 auto;
  font-family: 'JingNan BoBo Hei', 'Source Han Sans SC', 'PingFang SC', 'Microsoft YaHei', sans-serif;
}
.WxmOruAL {
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-pack: start;
  -webkit-justify-content: flex-start;
          justify-content: flex-start;
  gap: 0.5rem;
  -webkit-box-align: center;
  -webkit-align-items: center;
          align-items: center;
}
@media (max-width: 767px) {
  .WxmOruAL {
    gap: 0.25rem;
  }
}
.TWzNkum5 {
  display: none;
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-pack: start;
  -webkit-justify-content: flex-start;
          justify-content: flex-start;
  gap: 1rem;
  -webkit-box-align: center;
  -webkit-align-items: center;
          align-items: center;
  -webkit-box-flex: 1;
  -webkit-flex: 1;
          flex: 1;
  -webkit-box-pack: end;
  -webkit-justify-content: flex-end;
          justify-content: flex-end;
  padding-right: 2rem;
}
@media (min-width: 1024px) {
  .TWzNkum5 {
    display: -webkit-box;
    display: -webkit-flex;
    display: flex;
    -webkit-box-pack: start;
    -webkit-justify-content: flex-start;
            justify-content: flex-start;
    margin-left: 1.5rem;
  }
}
@media (min-width: 768px) and (max-width: 1023px) {
  .TWzNkum5 {
    display: -webkit-box;
    display: -webkit-flex;
    display: flex;
    -webkit-box-pack: start;
    -webkit-justify-content: flex-start;
            justify-content: flex-start;
    margin-left: 1.5rem;
    padding-right: 1rem;
  }
}
@media (max-width: 767px) {
  .TWzNkum5 {
    display: none;
  }
}
.Cfpkiz5W {
  border: none;
  background: none;
  margin: 0;
  outline: none;
  font-family: inherit;
  color: rgba(255, 255, 255, 0.82);
  font-family: 'JingNan BoBo Hei', 'Source Han Sans SC', 'PingFang SC', 'Microsoft YaHei', sans-serif;
  font-size: 1rem;
  text-decoration: none;
  padding: 0;
  cursor: pointer;
  -webkit-transition: color 0.3s ease;
  transition: color 0.3s ease;
  position: relative;
  display: inline-block;
  font-weight: bold;
  font-size: 1.125rem;
}
@media (max-width: 767px) {
  .Cfpkiz5W {
    display: none;
  }
}
.Cfpkiz5W:hover {
  color: #1890ff;
}
.Cfpkiz5W.x1_I8CNw {
  color: #ff6c00;
  font-size: 1.7rem;
  margin-right: 1.5rem;
}
@media (min-width: 768px) and (max-width: 1023px) {
  .Cfpkiz5W.x1_I8CNw {
    display: none;
  }
}
@media (min-width: 1024px) {
  .Cfpkiz5W.x1_I8CNw {
    display: none;
  }
}
.Cfpkiz5W.x1_I8CNw:hover {
  color: #ff6c00;
  opacity: 0.9;
}
.Cfpkiz5W._9tAt3YC:hover {
  color: rgba(255, 255, 255, 0.95);
}
.Cfpkiz5W._9tAt3YC.BY_mTe0r {
  color: #feba34;
}
.Cfpkiz5W._9tAt3YC.BY_mTe0r:hover {
  color: #feba34;
  opacity: 0.92;
}
.Cfpkiz5W._9tAt3YC.BY_mTe0r::after {
  content: '';
  position: absolute;
  bottom: -0.375rem;
  left: 50%;
  -webkit-transform: translateX(-50%);
          transform: translateX(-50%);
  width: 3.5625rem;
  height: 0.25rem;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) no-repeat center / contain;
}
.UELox73u {
  width: 3px;
  height: 1.125rem;
  background: rgba(255, 255, 255, 0.35);
  -webkit-flex-shrink: 0;
          flex-shrink: 0;
  margin: 0 0.25rem;
  border-radius: 4px;
}
.YxQQ0tvE {
  display: none;
  border: none;
  background: none;
  padding: 0;
  margin: 0;
  outline: none;
  font-family: inherit;
  padding: 0.5rem 1.5rem;
  background-color: #ff8f1d;
  color: #ffffff;
  border-radius: 999px;
  font-size: 1rem;
  cursor: pointer;
  -webkit-transition: opacity 0.2s ease, background-color 0.2s ease;
  transition: opacity 0.2s ease, background-color 0.2s ease;
}
.YxQQ0tvE:hover {
  opacity: 0.9;
}
.YxQQ0tvE:active {
  opacity: 0.8;
}
@media (min-width: 1024px) {
  .YxQQ0tvE {
    display: block;
  }
}
@media (min-width: 768px) and (max-width: 1023px) {
  .YxQQ0tvE {
    display: block;
  }
}
.DrhfkESi {
  display: none;
  position: relative;
  min-width: 0;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-direction: column;
          flex-direction: column;
  -webkit-box-align: stretch;
  -webkit-align-items: stretch;
          align-items: stretch;
}
@media (min-width: 768px) and (max-width: 1023px) {
  .DrhfkESi {
    display: -webkit-inline-box;
    display: -webkit-inline-flex;
    display: inline-flex;
    min-width: 12rem;
    max-width: 18rem;
  }
}
@media (min-width: 1024px) {
  .DrhfkESi {
    display: -webkit-inline-box;
    display: -webkit-inline-flex;
    display: inline-flex;
    min-width: 14rem;
    max-width: 20rem;
  }
}
@media (max-width: 767px) {
  .ACcRgdGU {
    display: -webkit-inline-box;
    display: -webkit-inline-flex;
    display: inline-flex;
    position: relative;
    max-width: 42vw;
    min-width: 0;
  }
}
@media (max-width: 767px) {
  .BZjvUcHB {
    display: -webkit-inline-box;
    display: -webkit-inline-flex;
    display: inline-flex;
    position: relative;
    max-width: 48vw;
    min-width: 0;
  }
}
.onBSJRgN .amrPemvn {
  border-radius: 0.75rem 0.75rem 0 0;
  border-bottom-color: transparent;
}
.amrPemvn {
  border: none;
  background: none;
  padding: 0;
  margin: 0;
  outline: none;
  font-family: inherit;
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
          align-items: center;
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
          justify-content: space-between;
  gap: 0.375rem;
  width: 100%;
  box-sizing: border-box;
  padding: 0.625rem 0.75rem;
  background-color: #3c302a;
  border: 1px solid #9c8466;
  border-radius: 0.75rem;
  cursor: pointer;
  -webkit-transition: background-color 0.2s ease;
  transition: background-color 0.2s ease;
}
.amrPemvn:hover {
  background-color: #483a32;
}
@media (max-width: 767px) {
  .amrPemvn {
    padding: 0.5rem 0.625rem;
    gap: 0.25rem;
  }
}
.FX3bc5nT {
  -webkit-box-flex: 1;
  -webkit-flex: 1;
          flex: 1;
  min-width: 0;
  font-family: 'Source Han Sans SC', 'PingFang SC', 'Microsoft YaHei', sans-serif;
  font-size: 0.875rem;
  font-weight: 700;
  color: #ffffff;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: left;
}
@media (max-width: 767px) {
  .FX3bc5nT {
    font-size: 0.625rem;
  }
}
@media (min-width: 1024px) {
  .FX3bc5nT {
    font-size: 1rem;
  }
}
.DFFBVVPO {
  -webkit-flex-shrink: 0;
          flex-shrink: 0;
  width: 0.875rem;
  height: 0.875rem;
  -webkit-transition: -webkit-transform 0.2s ease;
  transition: -webkit-transform 0.2s ease;
  transition: transform 0.2s ease;
  transition: transform 0.2s ease, -webkit-transform 0.2s ease;
}
@media (max-width: 767px) {
  .DFFBVVPO {
    width: 0.75rem;
    height: 0.75rem;
  }
}
.LnJ91sL2 {
  -webkit-transform: rotate(180deg);
          transform: rotate(180deg);
}
.gr1jL_46 {
  margin-top: 0;
  padding: 0;
  box-sizing: border-box;
  background-color: #3c302a;
  border: 1px solid #9c8466;
  border-top: none;
  border-radius: 0 0 0.75rem 0.75rem;
  box-shadow: none;
  overflow: hidden;
}
.ks3Nw2XX {
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  min-width: 100%;
  z-index: 1001;
}
.eTBjKnGi {
  position: fixed;
  z-index: 1002;
  min-width: 0;
  max-width: none;
}
.NNNXQaBb {
  height: 1px;
  margin: 0;
  background-color: #9c8466;
}
.DB7hJh15 {
  border: none;
  background: none;
  padding: 0;
  margin: 0;
  outline: none;
  font-family: inherit;
  display: block;
  width: 100%;
  box-sizing: border-box;
  padding: 0.625rem 0.75rem;
  text-align: center;
  font-family: 'Source Han Sans SC', 'PingFang SC', 'Microsoft YaHei', sans-serif;
  font-size: 0.875rem;
  font-weight: 700;
  color: #ffffff;
  cursor: pointer;
  -webkit-transition: background-color 0.2s ease;
  transition: background-color 0.2s ease;
}
.DB7hJh15:hover {
  background-color: #4e3e37;
}
.DB7hJh15:active {
  background-color: #5a483f;
}
@media (max-width: 767px) {
  .DB7hJh15 {
    padding: 0.5rem 0.625rem;
    font-size: 0.75rem;
  }
}
.ct51z5xU {
  display: -webkit-inline-box;
  display: -webkit-inline-flex;
  display: inline-flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-direction: column;
          flex-direction: column;
  -webkit-box-align: start;
  -webkit-align-items: flex-start;
          align-items: flex-start;
  max-width: 100%;
  min-width: 0;
  vertical-align: middle;
}
@media (min-width: 1024px) {
  .ct51z5xU {
    -webkit-box-orient: horizontal;
    -webkit-box-direction: normal;
    -webkit-flex-direction: row;
            flex-direction: row;
    -webkit-box-align: center;
    -webkit-align-items: center;
            align-items: center;
    gap: 0.625rem;
  }
}
.SaCm9NPx {
  display: none;
  box-sizing: border-box;
  width: 100%;
  margin-top: 0.125rem;
  color: #fa5900;
  font-family: "JingNan BoBo Hei";
  white-space: normal;
  overflow-wrap: break-word;
  word-break: normal;
  text-align: left;
  line-height: 1.15;
}
@media (max-width: 767px) {
  .SaCm9NPx {
    display: block;
    font-size: 0.725rem;
    font-weight: 700;
  }
}
@media (min-width: 768px) and (max-width: 1023px) {
  .SaCm9NPx {
    display: block;
    font-size: 1rem;
    font-weight: 700;
  }
}
@media (min-width: 1024px) {
  .SaCm9NPx {
    display: block;
    width: auto;
    margin-top: 0;
    margin-left: 1rem;
    font-size: 2rem;
    font-weight: 700;
    line-height: 1.2;
    white-space: nowrap;
  }
}
.jMVNYpxK {
  background-color: #2c2c2c;
}
@media (max-width: 767px) {
  .jMVNYpxK .bgBpjEza {
    -webkit-box-pack: start;
    -webkit-justify-content: flex-start;
            justify-content: flex-start;
    -webkit-box-flex: 1;
    -webkit-flex: 1 1 auto;
            flex: 1 1 auto;
    min-width: 0;
    gap: 0.625rem;
  }
}
@media (min-width: 768px) and (max-width: 1023px) {
  .jMVNYpxK .bgBpjEza {
    -webkit-box-pack: start;
    -webkit-justify-content: flex-start;
            justify-content: flex-start;
    -webkit-box-flex: 1;
    -webkit-flex: 1 1 auto;
            flex: 1 1 auto;
    min-width: 0;
    gap: 0.625rem;
  }
}
@media (min-width: 1024px) {
  .jMVNYpxK .bgBpjEza {
    -webkit-box-pack: start;
    -webkit-justify-content: flex-start;
            justify-content: flex-start;
    -webkit-box-flex: 1;
    -webkit-flex: 1 1 auto;
            flex: 1 1 auto;
    min-width: 0;
    gap: 0.75rem;
  }
}
@media (max-width: 767px) {
  .jMVNYpxK .o6H1hQYt {
    color: #ff8a16;
  }
}
@media (min-width: 768px) and (max-width: 1023px) {
  .jMVNYpxK .o6H1hQYt {
    color: #ff8a16;
  }
}
@media (min-width: 1024px) {
  .jMVNYpxK .o6H1hQYt {
    color: #ff8a16;
  }
}
@media (max-width: 767px) {
  .jMVNYpxK .ucMM2ewT {
    background: rgba(255, 255, 255, 0.35);
  }
}
@media (min-width: 768px) and (max-width: 1023px) {
  .jMVNYpxK .ucMM2ewT {
    background: rgba(255, 255, 255, 0.35);
  }
}
@media (min-width: 1024px) {
  .jMVNYpxK .ucMM2ewT {
    background: rgba(255, 255, 255, 0.35);
  }
}
@media (max-width: 767px) {
  .jMVNYpxK .WxmOruAL {
    margin-left: auto;
    -webkit-flex-shrink: 0;
            flex-shrink: 0;
  }
}
@media (min-width: 768px) and (max-width: 1023px) {
  .jMVNYpxK .WxmOruAL {
    margin-left: auto;
    -webkit-flex-shrink: 0;
            flex-shrink: 0;
  }
}
@media (min-width: 1024px) {
  .jMVNYpxK .WxmOruAL {
    margin-left: auto;
    -webkit-flex-shrink: 0;
            flex-shrink: 0;
  }
}
@media (max-width: 413px) {
  .jMVNYpxK .EI64mGw6,
  .jMVNYpxK .tflBBnun {
    gap: 0.375rem;
  }
  .jMVNYpxK .bPFeSkuu {
    height: 1.625rem;
  }
  .jMVNYpxK .aYCUJo6Z {
    max-height: 0.875rem;
  }
  .jMVNYpxK .SaCm9NPx {
    font-size: 0.5rem;
  }
  .jMVNYpxK .bgBpjEza {
    gap: 0.25rem;
  }
  .jMVNYpxK .TpiKZ7KT {
    font-size: 0.625rem;
  }
  .jMVNYpxK .ucMM2ewT {
    height: 0.625rem;
  }
  .jMVNYpxK .BZjvUcHB,
  .jMVNYpxK .ACcRgdGU {
    max-width: 32vw;
  }
  .jMVNYpxK .amrPemvn {
    padding: 0.25rem 0.375rem;
    gap: 0.125rem;
  }
  .jMVNYpxK .DB7hJh15 {
    padding: 0.25rem 0.375rem;
  }
  .jMVNYpxK .FX3bc5nT {
    font-size: 0.5625rem;
  }
  .jMVNYpxK .DFFBVVPO {
    width: 0.75rem;
    height: 0.75rem;
  }
}
@media (max-width: 767px) {
  .eEHixaFV .YxQQ0tvE {
    display: block !important;
    padding: 0.375rem 1.125rem;
    font-size: 0.75rem;
    font-weight: 700;
    background-color: #ff8a16;
    border-radius: 999px;
    white-space: nowrap;
  }
}
@media (min-width: 768px) and (max-width: 1023px) {
  .eEHixaFV .YxQQ0tvE {
    display: block !important;
    padding: 0.4375rem 1.25rem;
    font-size: 0.875rem;
    font-weight: 700;
    background-color: #ff8a16;
    border-radius: 999px;
    white-space: nowrap;
  }
}
@media (max-width: 767px) {
  .EI64mGw6 {
    gap: 0.625rem;
    -webkit-box-align: center;
    -webkit-align-items: center;
            align-items: center;
  }
}
@media (min-width: 768px) and (max-width: 1023px) {
  .EI64mGw6 {
    gap: 1rem;
    -webkit-box-align: center;
    -webkit-align-items: center;
            align-items: center;
  }
}
@media (min-width: 1024px) {
  .EI64mGw6 {
    gap: 1rem;
    -webkit-box-align: center;
    -webkit-align-items: center;
            align-items: center;
  }
}
.FjAMRuJf {
  background-color: #000;
}
@media (max-width: 413px) {
  .FjAMRuJf .tflBBnun {
    gap: 0.375rem;
  }
  .FjAMRuJf .bPFeSkuu {
    height: 1.625rem;
  }
  .FjAMRuJf .aYCUJo6Z {
    max-height: 0.875rem;
  }
  .FjAMRuJf .SaCm9NPx {
    font-size: 0.5rem;
  }
  .FjAMRuJf .bgBpjEza {
    gap: 0.25rem;
  }
  .FjAMRuJf .TpiKZ7KT {
    font-size: 0.625rem;
  }
  .FjAMRuJf .ucMM2ewT {
    height: 0.625rem;
  }
  .FjAMRuJf .BZjvUcHB,
  .FjAMRuJf .ACcRgdGU {
    max-width: 32vw;
  }
  .FjAMRuJf .amrPemvn {
    padding: 0.25rem 0.375rem;
    gap: 0.125rem;
  }
  .FjAMRuJf .DB7hJh15 {
    padding: 0.25rem 0.375rem;
  }
  .FjAMRuJf .FX3bc5nT {
    font-size: 0.5625rem;
  }
  .FjAMRuJf .DFFBVVPO {
    width: 0.75rem;
    height: 0.75rem;
  }
}
@media (max-width: 767px) {
  .tflBBnun {
    gap: 1rem;
  }
}
@media (min-width: 768px) and (max-width: 1023px) {
  .tflBBnun {
    gap: 1rem;
  }
}
@media (min-width: 1024px) {
  .tflBBnun {
    gap: 1rem;
  }
}
.bgBpjEza {
  display: none;
}
@media (max-width: 767px) {
  .bgBpjEza {
    display: -webkit-box;
    display: -webkit-flex;
    display: flex;
    -webkit-box-align: center;
    -webkit-align-items: center;
            align-items: center;
    -webkit-box-pack: left;
    -webkit-justify-content: left;
            justify-content: left;
    gap: 0.5rem;
    -webkit-box-flex: 1;
    -webkit-flex: 1;
            flex: 1;
    min-width: 0;
  }
}
.TpiKZ7KT {
  border: none;
  background: none;
  padding: 0;
  margin: 0;
  outline: none;
  font-family: inherit;
  position: relative;
  color: #ffffff;
  font-size: 0.75rem;
  font-weight: 700;
  text-decoration: none;
  white-space: nowrap;
  cursor: pointer;
  -webkit-transition: opacity 0.2s ease, color 0.2s ease;
  transition: opacity 0.2s ease, color 0.2s ease;
}
.TpiKZ7KT:hover {
  opacity: 0.85;
}
.o6H1hQYt {
  color: #feba34;
}
.o6H1hQYt::after {
  content: '';
  position: absolute;
  bottom: -0.25rem;
  left: 50%;
  -webkit-transform: translateX(-50%);
          transform: translateX(-50%);
  width: 2.75rem;
  height: 0.25rem;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) no-repeat center / contain;
  pointer-events: none;
}
@media (max-width: 413px) {
  .o6H1hQYt::after {
    width: 2.25rem;
    bottom: -0.1875rem;
  }
}
.ucMM2ewT {
  width: 1px;
  height: 0.875rem;
  background: rgba(255, 255, 255, 0.35);
  -webkit-flex-shrink: 0;
          flex-shrink: 0;
}
@media (max-width: 767px) {
  .WcW8I6HY {
    display: block !important;
  }
}
@media (min-width: 768px) and (max-width: 1023px) {
  .WcW8I6HY {
    display: block !important;
  }
}
@media (max-width: 1023px) {
  .kcKlUkRc {
    display: none !important;
  }
}
.FmYnbzty {
  display: none;
  border: none;
  background: none;
  padding: 0;
  margin: 0;
  cursor: pointer;
  outline: none;
  font-family: inherit;
  min-height: 2.75rem;
  min-width: 2.75rem;
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
          align-items: center;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
          justify-content: center;
  color: #ffffff;
  padding: 0.25rem;
}
@media (max-width: 767px) {
  .FmYnbzty {
    display: -webkit-box;
    display: -webkit-flex;
    display: flex;
  }
}
@media (min-width: 1024px) {
  .FmYnbzty {
    display: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Layout/Header.module.less","webpack://./src/styles/mixins.less"],"names":[],"mappings":"AAYA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,aAAA;EACA,iBAAA;EACA,6BAAA;AAXF;AAaE;;EAEE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,oBAAA;AAXJ;AAcE;EACE,OAAA;EACA,UAAA;EACA,kFAAA;AAZJ;AAeE;EACE,QAAA;EACA,UAAA;EACA,6DAAA;EACA,4CAAA;EACA,8BAAA;AAbJ;ACvBE;EAAA;IDwCE,YAAA;IACA,oBAAA;IACA,iBAAA;IACA,gBAAA;EAbF;EAeE;IACE,kCAAA;IACA,uCAAA;EAbJ;EAgBE;IACE,sCAAA;IACA,gBAAA;EAdJ;AACF;AC3BE;EAAA;ID6CE,oBAAA;IAAA,qBAAA;IAAA,aAAA;IACA,yBAAA;IAAA,2BAAA;YAAA,mBAAA;IACA,YAAA;EAdF;EAgBE;IACE,8BAAA;IACA,mCAAA;EAdJ;EAiBE;IACE,kCAAA;IACA,cAAA;EAfJ;AACF;ACpCE;EAAA;IDuDE,oBAAA;IAAA,qBAAA;IAAA,aAAA;IACA,yBAAA;IAAA,2BAAA;YAAA,mBAAA;IACA,YAAA;EAfF;EAiBE;IACE,8BAAA;IACA,mCAAA;EAfJ;EAkBE;IACE,kCAAA;IACA,cAAA;EAhBJ;AACF;AAqBA;EACE,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,qBAAA;AAnBF;AC/DE;EAAA;IDsFE,aAAA;EAnBF;AACF;ACxDE;EAAA;ID+EI,aAAA;EAnBJ;AACF;AC7DE;EAAA;IDqFI,aAAA;EApBJ;AACF;AC1FE;EAAA;IDmHI,aAAA;EArBJ;AACF;AC/FE;EAAA;IDyHI,aAAA;EAtBJ;AACF;AClFE;EAAA;ID4GE,kBAAA;IACA,SAAA;IACA,QAAA;IACA,YAAA;IACA,UAAA;IACA,cAAA;IACA,mBAAA;IACA,yCAAA;IACA,oBAAA;IAAA,qBAAA;IAAA,aAAA;IACA,yBAAA;IAAA,2BAAA;YAAA,mBAAA;IACA,eAAA;IACA,cAAA;IACA,YAAA;EAtBF;AACF;AAyBA;EACE,WAAA;AAvBF;AA0BA;EC7EE,oBAAA;EAAA,qBAAA;EAAA,aAAA;EAEA,uBAAA;EAAA,mCAAA;UAAA,2BAAA;ED6EA,yBAAA;EAAA,2BAAA;UAAA,mBAAA;EACA,WAAA;EACA,eAAA;AAvBF;AC/HE;EAAA;IDyJE,WAAA;EAtBF;AACF;AAyBA;EACE,WAAA;EACA,YAAA;EACA,qBAAA;EAEA,sBAAA;UAAA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,oBAAA;EAAA,qBAAA;EAAA,aAAA;EACA,yBAAA;EAAA,2BAAA;UAAA,mBAAA;EACA,wBAAA;EAAA,+BAAA;UAAA,uBAAA;EACA,wCAAA;AAxBF;AChJE;EAAA;ID2KE,WAAA;IACA,YAAA;EAvBF;AACF;ACpIE;EAAA;ID6JE,WAAA;IACA,YAAA;IACA,mBAAA;EArBF;AACF;AAwBA;EACE,WAAA;EACA,YAAA;EACA,oBAAA;KAAA,iBAAA;EACA,qBAAA;AAtBF;AAyBA;EACE,WAAA;EACA,YAAA;AAvBF;AA2BA;EACE,mBAAA;EAAA,eAAA;UAAA,OAAA;EACA,oBAAA;EAAA,qBAAA;EAAA,aAAA;EACA,4BAAA;EAAA,6BAAA;EAAA,8BAAA;UAAA,sBAAA;EACA,YAAA;EACA,kBAAA;AAzBF;AA4BA;EACE,aAAA;AA1BF;AC/JE;EAAA;ID4LE,cAAA;IACA,eAAA;IACA,gBAAA;IACA,cAAA;IACA,sBAAA;EAzBF;AACF;AA4BA;ECjJE,oBAAA;EAAA,qBAAA;EAAA,aAAA;EAEA,uBAAA;EAAA,mCAAA;UAAA,2BAAA;EDiJA,yBAAA;EAAA,2BAAA;UAAA,mBAAA;EACA,YAAA;EACA,WAAA;AAzBF;AA4BA;EACE,cAAA;EACA,mBAAA;AA1BF;ACrME;EAAA;IDkOE,oBAAA;EAzBF;AACF;AA4BA;EACE,cAAA;EACA,mBAAA;EACA,eAAA;EACA,qCAAA;EAAA,6BAAA;AA1BF;AA4BE;EACE,YAAA;AA1BJ;AA6BE;EACE,YAAA;AA3BJ;ACtNE;EAAA;IDqPE,kBAAA;EA3BF;AACF;AA8BA;EACE,qBAAA;EACA,WAAA;EACA,WAAA;EACA,sBAAA;EACA,oBAAA;EACA,eAAA;EACA,qCAAA;EAAA,6BAAA;AA5BF;AA8BE;EACE,YAAA;AA5BJ;AA+BE;EACE,YAAA;AA7BJ;AC1OE;EAAA;ID2QE,YAAA;IACA,oBAAA;EA7BF;AACF;AAgCA;EC3ME,oBAAA;EAAA,qBAAA;EAAA,aAAA;EAEA,uBAAA;EAAA,mCAAA;UAAA,2BAAA;ED2MA,yBAAA;EAAA,2BAAA;UAAA,mBAAA;EACA,YAAA;EACA,uBAAA;UAAA,eAAA;EACA,mBAAA;AA7BF;AAgCA;EACE,cAAA;EAEA,eAAA;EACA,mCAAA;EAAA,2BAAA;AA/BF;AAiCE;EACE,cAAA;AA/BJ;AAoCA;EACE,cAAA;EACA,mBAAA;AAlCF;ACpQE;EAAA;IDySE,mBAAA;EAjCF;AACF;AAoCA;ECxME,gBAAA;EACA,UAAA;EACA,SAAA;EAEA,aAAA;EACA,oBAAA;EAjDA,oBAAA;EAAA,qBAAA;EAAA,aAAA;EACA,yBAAA;EAAA,2BAAA;UAAA,mBAAA;EACA,wBAAA;EAAA,+BAAA;UAAA,uBAAA;EDqPA,yBAAA;EACA,uBAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;EACA,qCAAA;EAAA,6BAAA;AA5BF;AA8BE;EACE,YAAA;AA5BJ;AA+BE;EACE,YAAA;AA7BJ;AC/RE;EAAA;IDgUE,0BAAA;EA7BF;AACF;AAgCA;EACE,kBAAA;EACA,UAAA;EACA,oBAAA;EAAA,qBAAA;EAAA,aAAA;EACA,yBAAA;EAAA,2BAAA;UAAA,mBAAA;EACA,cAAA;EACA,WAAA;AA9BF;AC5SE;EAAA;ID6UE,iBAAA;IACA,yBAAA;IAAA,sCAAA;YAAA,8BAAA;EA7BF;AACF;ACtSE;EAAA;IDqUE,qBAAA;IACA,yBAAA;IAAA,sCAAA;YAAA,8BAAA;IACA,WAAA;IACA,sBAAA;EA3BF;AACF;ACxSE;EAAA;IDsUE,yBAAA;IAAA,sCAAA;YAAA,8BAAA;IACA,oBAAA;IACA,WAAA;EA1BF;AACF;AA8BA;EC1RE,oBAAA;EAAA,qBAAA;EAAA,aAAA;EAEA,uBAAA;EAAA,mCAAA;UAAA,2BAAA;ED0RA,yBAAA;EAAA,2BAAA;UAAA,mBAAA;EACA,sBAAA;UAAA,cAAA;AA3BF;AA8BA;EACE,qBAAA;EACA,oBAAA;EAAA,qBAAA;EAAA,aAAA;EACA,yBAAA;EAAA,2BAAA;UAAA,mBAAA;EACA,YAAA;AA5BF;AC3TE;EAAA;ID0VE,WAAA;EA3BF;AACF;AA8BA;EACE,eAAA;EACA,WAAA;EACA,sBAAA;KAAA,mBAAA;EACA,cAAA;EACA,sBAAA;UAAA,cAAA;AA5BF;ACzVE;EAAA;IDwXE,gBAAA;EA3BF;AACF;AClVE;EAAA;IDgXE,eAAA;EA1BF;AACF;ACjVE;EAAA;ID8WE,YAAA;EAzBF;AACF;AA4BA;EACE,cAAA;EACA,WAAA;EACA,eAAA;EACA,sBAAA;KAAA,mBAAA;EACA,cAAA;EACA,sBAAA;UAAA,cAAA;AA1BF;AChXE;EAAA;ID6YE,WAAA;IACA,eAAA;IACA,YAAA;IACA,gBAAA;IACA,8BAAA;YAAA,sBAAA;EAzBF;AACF;AC7WE;EAAA;IDyYE,WAAA;IACA,eAAA;IACA,YAAA;IACA,mBAAA;IACA,8BAAA;YAAA,sBAAA;EAxBF;AACF;AChXE;EAAA;ID2YE,WAAA;IACA,YAAA;IACA,gBAAA;IACA,aAAA;IACA,0BAAA;YAAA,kBAAA;EAvBF;AACF;AA0BA;EChWE,oBAAA;EAAA,qBAAA;EAAA,aAAA;EACA,yBAAA;EAAA,2BAAA;UAAA,mBAAA;EACA,uBAAA;EAAA,mCAAA;UAAA,2BAAA;EDgWA,WAAA;AAtBF;AAyBE;EAAA;IACE,eAAA;IACA,YAAA;IACA,OAAA;IACA,QAAA;IACA,4BAAA;IAAA,6BAAA;IAAA,8BAAA;YAAA,sBAAA;IACA,mBAAA;IACA,yCAAA;IACA,oCAAA;YAAA,4BAAA;IACA,+CAAA;IAAA,uCAAA;IAAA,+BAAA;IAAA,4DAAA;IACA,MAAA;IACA,aAAA;IACA,kBAAA;EAtBF;EAwBE;IACE,gCAAA;YAAA,wBAAA;EAtBJ;AACF;AClZE;EAAA;ID4aE,aAAA;EAtBF;AACF;AAyBA;EACE,cAAA;EACA,qBAAA;EACA,eAAA;EACA,mGAAA;EACA,mCAAA;EAAA,2BAAA;EClYA,oBAAA;EAAA,qBAAA;EAAA,aAAA;EAEA,uBAAA;EAAA,mCAAA;UAAA,2BAAA;EDkYA,yBAAA;EAAA,2BAAA;UAAA,mBAAA;EACA,WAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;EACA,oBAAA;EACA,UAAA;AAtBF;AAwBE;EACE,cAAA;AAtBJ;AC5bE;EAAA;IDsdE,kBAAA;IACA,cAAA;IACA,gCAAA;IACA,UAAA;IACA,oBAAA;IC3WF,mBAAA;IACA,kBAAA;ID4WE,oBAAA;IAAA,qBAAA;IAAA,aAAA;IACA,wBAAA;IAAA,+BAAA;YAAA,uBAAA;IACA,yBAAA;IAAA,2BAAA;YAAA,mBAAA;IACA,mBAAA;IACA,SAAA;EArBF;AACF;AChcE;EAAA;IDudE,kBAAA;IACA,cAAA;IACA,gCAAA;IACA,UAAA;IACA,oBAAA;ICxXF,mBAAA;IACA,kBAAA;IDyXE,oBAAA;IAAA,qBAAA;IAAA,aAAA;IACA,wBAAA;IAAA,+BAAA;YAAA,uBAAA;IACA,yBAAA;IAAA,2BAAA;YAAA,mBAAA;IACA,mBAAA;IACA,SAAA;EAlBF;AACF;AAoBE;EACE,mBAAA;AAlBJ;AAsBA;EACE,oBAAA;EAAA,qBAAA;EAAA,aAAA;EACA,yBAAA;EAAA,2BAAA;UAAA,mBAAA;EACA,wBAAA;EAAA,+BAAA;UAAA,uBAAA;EACA,sBAAA;UAAA,cAAA;EACA,cAAA;EACA,eAAA;EACA,cAAA;AApBF;ACxeE;EAAA;ID+fE,cAAA;IACA,eAAA;EAnBF;AACF;AAsBA;EACE,mBAAA;EAAA,sBAAA;UAAA,cAAA;EACA,mGAAA;AApBF;AAuBA;ECpcE,oBAAA;EAAA,qBAAA;EAAA,aAAA;EAEA,uBAAA;EAAA,mCAAA;UAAA,2BAAA;EDocA,WAAA;EACA,yBAAA;EAAA,2BAAA;UAAA,mBAAA;AApBF;ACxfE;EAAA;ID+gBE,YAAA;EAnBF;AACF;AAgCA;EACE,aAAA;ECzdA,oBAAA;EAAA,qBAAA;EAAA,aAAA;EAEA,uBAAA;EAAA,mCAAA;UAAA,2BAAA;EDydA,SAAA;EACA,yBAAA;EAAA,2BAAA;UAAA,mBAAA;EACA,mBAAA;EAAA,eAAA;UAAA,OAAA;EACA,qBAAA;EAAA,iCAAA;UAAA,yBAAA;EACA,mBAAA;AA7BF;ACrfE;EAAA;IDqhBE,oBAAA;IAAA,qBAAA;IAAA,aAAA;IACA,uBAAA;IAAA,mCAAA;YAAA,2BAAA;IACA,mBAAA;EA5BF;AACF;AClgBE;EAAA;IDgiBE,oBAAA;IAAA,qBAAA;IAAA,aAAA;IACA,uBAAA;IAAA,mCAAA;YAAA,2BAAA;IACA,mBAAA;IACA,mBAAA;EA1BF;AACF;ACthBE;EAAA;IDkjBE,aAAA;EAxBF;AACF;AA2BA;ECldE,YAAA;EACA,gBAAA;EAEA,SAAA;EAEA,aAAA;EACA,oBAAA;ED8cA,gCAAA;EACA,mGAAA;EACA,eAAA;EACA,qBAAA;EACA,UAAA;EACA,eAAA;EACA,mCAAA;EAAA,2BAAA;EACA,kBAAA;EACA,qBAAA;EACA,iBAAA;EACA,mBAAA;AArBF;AC7iBE;EAAA;IDokBE,aAAA;EAnBF;AACF;AAqBE;EACE,cAAA;AAnBJ;AAsBE;EACE,cAAA;EACA,iBAAA;EACA,oBAAA;AApBJ;AC9iBE;EAAA;IDqkBI,aAAA;EAnBJ;AACF;AC7iBE;EAAA;IDmkBI,aAAA;EAlBJ;AACF;AAoBI;EACE,cAAA;EACA,YAAA;AAlBN;AAuBI;EACE,gCAAA;AArBN;AAwBI;EACE,cAAA;AAtBN;AAwBM;EACE,cAAA;EACA,aAAA;AAtBR;AAyBM;EACE,WAAA;EACA,kBAAA;EACA,iBAAA;EACA,SAAA;EACA,mCAAA;UAAA,2BAAA;EACA,gBAAA;EACA,eAAA;EACA,8EAAA;AAvBR;AA6BA;EACE,UAAA;EACA,gBAAA;EACA,qCAAA;EACA,sBAAA;UAAA,cAAA;EACA,iBAAA;EACA,kBAAA;AA3BF;AA+BA;EACE,aAAA;EChiBA,YAAA;EACA,gBAAA;EACA,UAAA;EACA,SAAA;EAEA,aAAA;EACA,oBAAA;ED4hBA,sBAAA;EACA,yBAAA;EACA,cAAA;EACA,oBAAA;EACA,eAAA;EACA,eAAA;EACA,iEAAA;EAAA,yDAAA;AAxBF;AA2BE;EACE,YAAA;AAzBJ;AA4BE;EACE,YAAA;AA1BJ;ACxmBE;EAAA;IDqoBE,cAAA;EAzBF;AACF;ACnnBE;EAAA;ID+oBE,cAAA;EAxBF;AACF;AA6BA;EACE,aAAA;EACA,kBAAA;EACA,YAAA;EACA,4BAAA;EAAA,6BAAA;EAAA,8BAAA;UAAA,sBAAA;EACA,0BAAA;EAAA,4BAAA;UAAA,oBAAA;AA3BF;AC/nBE;EAAA;ID6pBE,2BAAA;IAAA,4BAAA;IAAA,oBAAA;IACA,gBAAA;IACA,gBAAA;EA1BF;AACF;AChoBE;EAAA;ID6pBE,2BAAA;IAAA,4BAAA;IAAA,oBAAA;IACA,gBAAA;IACA,gBAAA;EAzBF;AACF;ACzpBE;EAAA;IDurBE,2BAAA;IAAA,4BAAA;IAAA,oBAAA;IACA,kBAAA;IACA,eAAA;IACA,YAAA;EA1BF;AACF;ACjqBE;EAAA;IDgsBE,2BAAA;IAAA,4BAAA;IAAA,oBAAA;IACA,kBAAA;IACA,eAAA;IACA,YAAA;EA3BF;AACF;AA8BA;EACE,kCAAA;EACA,gCAAA;AA5BF;AA+BA;ECxmBE,YAAA;EACA,gBAAA;EACA,UAAA;EACA,SAAA;EAEA,aAAA;EACA,oBAAA;EDomBA,oBAAA;EAAA,qBAAA;EAAA,aAAA;EACA,yBAAA;EAAA,2BAAA;UAAA,mBAAA;EACA,yBAAA;EAAA,sCAAA;UAAA,8BAAA;EACA,aAAA;EACA,WAAA;EACA,sBAAA;EACA,yBAAA;EACA,yBAAA;EACA,yBAAA;EACA,sBAAA;EACA,eAAA;EACA,8CAAA;EAAA,sCAAA;AAxBF;AA0BE;EACE,yBAAA;AAxBJ;ACpsBE;EAAA;IDguBE,wBAAA;IACA,YAAA;EAxBF;AACF;AA2BA;EACE,mBAAA;EAAA,eAAA;UAAA,OAAA;EACA,YAAA;EACA,+EAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,gBAAA;AAzBF;ACttBE;EAAA;IDkvBE,mBAAA;EAxBF;AACF;ACzsBE;EAAA;IDouBE,eAAA;EAvBF;AACF;AA0BA;EACE,sBAAA;UAAA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,+CAAA;EAAA,uCAAA;EAAA,+BAAA;EAAA,4DAAA;AAxBF;ACtuBE;EAAA;IDiwBE,cAAA;IACA,eAAA;EAvBF;AACF;AA0BA;EACE,iCAAA;UAAA,yBAAA;AAxBF;AA4BA;EACE,aAAA;EACA,UAAA;EACA,sBAAA;EACA,yBAAA;EACA,yBAAA;EACA,gBAAA;EACA,kCAAA;EACA,gBAAA;EACA,gBAAA;AA1BF;AA8BA;EACE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,eAAA;EACA,aAAA;AA5BF;AAgCA;EACE,eAAA;EACA,aAAA;EACA,YAAA;EACA,eAAA;AA9BF;AAiCA;EACE,WAAA;EACA,SAAA;EACA,yBAAA;AA/BF;AAkCA;EC3sBE,YAAA;EACA,gBAAA;EACA,UAAA;EACA,SAAA;EAEA,aAAA;EACA,oBAAA;EDusBA,cAAA;EACA,WAAA;EACA,sBAAA;EACA,yBAAA;EACA,kBAAA;EACA,+EAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,8CAAA;EAAA,sCAAA;AA3BF;AA6BE;EACE,yBAAA;AA3BJ;AA8BE;EACE,yBAAA;AA5BJ;ACtyBE;EAAA;IDs0BE,wBAAA;IACA,kBAAA;EA5BF;AACF;AA+BA;EACE,2BAAA;EAAA,4BAAA;EAAA,oBAAA;EACA,4BAAA;EAAA,6BAAA;EAAA,8BAAA;UAAA,sBAAA;EACA,wBAAA;EAAA,+BAAA;UAAA,uBAAA;EACA,eAAA;EACA,YAAA;EACA,sBAAA;AA7BF;AClyBE;EAAA;IDk0BE,8BAAA;IAAA,6BAAA;IAAA,2BAAA;YAAA,mBAAA;IACA,yBAAA;IAAA,2BAAA;YAAA,mBAAA;IACA,aAAA;EA5BF;AACF;AA+BA;EACE,aAAA;EACA,sBAAA;EACA,WAAA;EACA,oBAAA;EACA,cAAA;EACA,+BAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AA7BF;ACx0BE;EAAA;IDw2BE,cAAA;IACA,mBAAA;IACA,gBAAA;EA5BF;AACF;ACn0BE;EAAA;IDk2BE,cAAA;IACA,eAAA;IACA,gBAAA;EA3BF;AACF;ACp0BE;EAAA;IDk2BE,cAAA;IACA,WAAA;IACA,aAAA;IACA,iBAAA;IACA,eAAA;IACA,gBAAA;IACA,gBAAA;IACA,mBAAA;EA1BF;AACF;AAgCA;EACE,yBAAA;AA9BF;ACr2BE;EAAA;IDu4BI,uBAAA;IAAA,mCAAA;YAAA,2BAAA;IACA,mBAAA;IAAA,sBAAA;YAAA,cAAA;IACA,YAAA;IACA,aAAA;EA9BJ;AACF;ACj2BE;EAAA;IDk4BI,uBAAA;IAAA,mCAAA;YAAA,2BAAA;IACA,mBAAA;IAAA,sBAAA;YAAA,cAAA;IACA,YAAA;IACA,aAAA;EA7BJ;AACF;ACn2BE;EAAA;IDm4BI,uBAAA;IAAA,mCAAA;YAAA,2BAAA;IACA,mBAAA;IAAA,sBAAA;YAAA,cAAA;IACA,YAAA;IACA,YAAA;EA5BJ;AACF;AC73BE;EAAA;ID85BI,cAAA;EA7BJ;AACF;ACt3BE;EAAA;IDs5BI,cAAA;EA5BJ;AACF;ACr3BE;EAAA;IDo5BI,cAAA;EA3BJ;AACF;AC54BE;EAAA;ID46BI,qCAAA;EA5BJ;AACF;ACr4BE;EAAA;IDo6BI,qCAAA;EA3BJ;AACF;ACp4BE;EAAA;IDk6BI,qCAAA;EA1BJ;AACF;AC35BE;EAAA;ID27BI,iBAAA;IACA,sBAAA;YAAA,cAAA;EA5BJ;AACF;ACr5BE;EAAA;IDo7BI,iBAAA;IACA,sBAAA;YAAA,cAAA;EA3BJ;AACF;ACr5BE;EAAA;IDm7BI,iBAAA;IACA,sBAAA;YAAA,cAAA;EA1BJ;AACF;ACv6BE;EAAA;;IDw8BI,aAAA;EA5BJ;EC56BA;ID48BI,gBAAA;EA7BJ;EC/6BA;IDg9BI,oBAAA;EA9BJ;ECl7BA;IDo9BI,iBAAA;EA/BJ;ECr7BA;IDw9BI,YAAA;EAhCJ;ECx7BA;ID49BI,mBAAA;EAjCJ;EC37BA;IDg+BI,gBAAA;EAlCJ;EC97BA;;IDq+BI,eAAA;EAnCJ;ECl8BA;IDy+BI,yBAAA;IACA,aAAA;EApCJ;ECt8BA;ID8+BI,yBAAA;EArCJ;ECz8BA;IDk/BI,oBAAA;EAtCJ;EC58BA;IDs/BI,cAAA;IACA,eAAA;EAvCJ;AACF;ACv9BE;EAAA;IDqgCI,yBAAA;IACA,0BAAA;IACA,kBAAA;IACA,gBAAA;IACA,yBAAA;IACA,oBAAA;IACA,mBAAA;EA1CJ;AACF;ACt9BE;EAAA;IDmgCI,yBAAA;IACA,0BAAA;IACA,mBAAA;IACA,gBAAA;IACA,yBAAA;IACA,oBAAA;IACA,mBAAA;EAzCJ;AACF;AC7+BE;EAAA;ID4hCE,aAAA;IACA,yBAAA;IAAA,2BAAA;YAAA,mBAAA;EA3CF;AACF;ACv+BE;EAAA;IDqhCE,SAAA;IACA,yBAAA;IAAA,2BAAA;YAAA,mBAAA;EA1CF;AACF;ACv+BE;EAAA;IDohCE,SAAA;IACA,yBAAA;IAAA,2BAAA;YAAA,mBAAA;EAzCF;AACF;AA4CA;EACE,sBAAA;AA1CF;AC5/BE;EAAA;ID0iCI,aAAA;EA1CJ;EChgCA;ID8iCI,gBAAA;EA3CJ;ECngCA;IDkjCI,oBAAA;EA5CJ;ECtgCA;IDsjCI,iBAAA;EA7CJ;ECzgCA;ID0jCI,YAAA;EA9CJ;EC5gCA;ID8jCI,mBAAA;EA/CJ;EC/gCA;IDkkCI,gBAAA;EAhDJ;EClhCA;;IDukCI,eAAA;EAjDJ;ECthCA;ID2kCI,yBAAA;IACA,aAAA;EAlDJ;EC1hCA;IDglCI,yBAAA;EAnDJ;EC7hCA;IDolCI,oBAAA;EApDJ;EChiCA;IDwlCI,cAAA;IACA,eAAA;EArDJ;AACF;AC3iCE;EAAA;IDsmCE,SAAA;EAvDF;AACF;ACpiCE;EAAA;ID8lCE,SAAA;EAtDF;AACF;ACniCE;EAAA;ID4lCE,SAAA;EArDF;AACF;AAwDA;EACE,aAAA;AAtDF;AC7jCE;EAAA;IDsnCE,oBAAA;IAAA,qBAAA;IAAA,aAAA;IACA,yBAAA;IAAA,2BAAA;YAAA,mBAAA;IACA,sBAAA;IAAA,6BAAA;YAAA,qBAAA;IACA,WAAA;IACA,mBAAA;IAAA,eAAA;YAAA,OAAA;IACA,YAAA;EArDF;AACF;AAwDA;EC3hCE,YAAA;EACA,gBAAA;EACA,UAAA;EACA,SAAA;EAEA,aAAA;EACA,oBAAA;EDuhCA,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,qBAAA;EACA,mBAAA;EACA,eAAA;EACA,sDAAA;EAAA,8CAAA;AAjDF;AAmDE;EACE,aAAA;AAjDJ;AAqDA;EACE,cAAA;AAnDF;AAqDE;EACE,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,SAAA;EACA,mCAAA;UAAA,2BAAA;EACA,cAAA;EACA,eAAA;EACA,8EAAA;EACA,oBAAA;AAnDJ;AClmCE;EDypCE;IACE,cAAA;IACA,kBAAA;EApDJ;AACF;AAwDA;EACE,UAAA;EACA,gBAAA;EACA,qCAAA;EACA,sBAAA;UAAA,cAAA;AAtDF;ACpnCE;EAAA;ID+qCE,yBAAA;EAvDF;AACF;AC7mCE;EAAA;IDuqCE,yBAAA;EAtDF;AACF;AA0DE;EAAA;IACE,wBAAA;EAvDF;AACF;AA0DA;EACE,aAAA;EC1lCA,YAAA;EACA,gBAAA;EACA,UAAA;EACA,SAAA;EACA,eAAA;EACA,aAAA;EACA,oBAAA;EAKA,mBAAA;EACA,kBAAA;EAvDA,oBAAA;EAAA,qBAAA;EAAA,aAAA;EACA,yBAAA;EAAA,2BAAA;UAAA,mBAAA;EACA,wBAAA;EAAA,+BAAA;UAAA,uBAAA;EDuoCA,cAAA;EACA,gBAAA;AA/CF;ACppCE;EAAA;IDssCE,oBAAA;IAAA,qBAAA;IAAA,aAAA;EA9CF;AACF;ACvoCE;EAAA;IDwrCE,aAAA;EA7CF;AACF","sourcesContent":["@import '@/styles/variables.less';\n@import '@/styles/mixins.less';\n\n@header-bg-image: '../../assets/img2/pay_top_main_bg.png';\n@header-bg-source-width: 410;\n@header-bg-source-height: 110;\n@header-bg-bar-height: 104;\n@header-bg-fixed-end: 0.8;\n@header-bg-full-height-ratio: @header-bg-source-height / @header-bg-bar-height;\n@header-bg-left-width-ratio: (@header-bg-source-width * @header-bg-fixed-end) / @header-bg-bar-height;\n@header-bg-seam-overlap: 2px;\n\n.header {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  z-index: @z-index-dropdown;\n  overflow: visible;\n  background-color: transparent;\n\n  &::before,\n  &::after {\n    content: '';\n    position: absolute;\n    top: 0;\n    pointer-events: none;\n  }\n\n  &::before {\n    left: 0;\n    z-index: 0;\n    background: url(@header-bg-image) left top / auto 100% no-repeat;\n  }\n\n  &::after {\n    right: 0;\n    z-index: 1;\n    background: url(@header-bg-image) no-repeat;\n    background-size: calc(100% / (1 - @header-bg-fixed-end)) 100%;\n    background-position: right top;\n  }\n\n  .mobile({\n    height: auto;\n    min-height: 3.125rem; // 50px\n    padding: @spacing-sm 0;\n    overflow: hidden;\n\n    &::before {\n      height: calc(3.125rem * @header-bg-full-height-ratio);\n      width: calc(3.125rem * @header-bg-left-width-ratio + @header-bg-seam-overlap);\n    }\n\n    &::after {\n      left: calc(3.125rem * @header-bg-left-width-ratio - @header-bg-seam-overlap);\n      height: 3.125rem;\n    }\n  });\n\n  .tablet({\n    display: flex;\n    align-items: center;\n    height: 5rem;\n\n    &::before {\n      height: calc(5rem * @header-bg-full-height-ratio);\n      width: calc(5rem * @header-bg-left-width-ratio + @header-bg-seam-overlap);\n    }\n\n    &::after {\n      left: calc(5rem * @header-bg-left-width-ratio - @header-bg-seam-overlap);\n      height: 5.3rem;\n    }\n  });\n\n  .desktop({\n    display: flex;\n    align-items: center;\n    height: 5rem;\n\n    &::before {\n      height: calc(5rem * @header-bg-full-height-ratio);\n      width: calc(5rem * @header-bg-left-width-ratio + @header-bg-seam-overlap);\n    }\n\n    &::after {\n      left: calc(5rem * @header-bg-left-width-ratio - @header-bg-seam-overlap);\n      height: 5.3rem;\n    }\n  });\n}\n\n\n.loginBar {\n  position: relative;\n  background: @background-color; // 灰色背景\n  padding: @spacing-sm;\n  padding-top: 4.375rem; // 70px\n\n  // 平板端不展示 loginBar（商品页等仅在手机端使用的场景由下方 modifier 控制）\n  .tablet({\n    display: none;\n  });\n\n  &.loginBarHiddenOnDesktop {\n    .tablet-up({\n      display: none;\n    });\n  }\n\n  &.loginBarProductsMobileOnly {\n    .tablet-up({\n      display: none;\n    });\n  }\n\n  &.loginBarProductsMobileHidden {\n    .mobile({\n      display: none;\n    });\n  }\n\n  &.loginBarHomeMobileHidden {\n    .mobile({\n      display: none;\n    });\n  }\n  \n  .desktop({\n    position: absolute;\n    top: 14vw;\n    left: 1%;\n    z-index: 999;\n    width: 98%;\n    margin: 0 auto;\n    border-radius: 1rem;\n    box-shadow: @box-shadow-md;\n    display: flex;\n    align-items: center;\n    padding: 0 2rem;\n    padding-top: 0;\n    height: 7rem;\n  });\n}\n\n.loginContent {\n  width: 100%;\n}\n\n.userInfo {\n  .flex-start();\n  align-items: center;\n  gap: @spacing-sm;\n  cursor: pointer;\n\n  .mobile({\n    gap: @spacing-sm;\n  });\n}\n\n.avatar {\n  width: 3rem; // 40px\n  height: 3rem; // 40px\n  border-radius: @border-radius-md; // 方形圆角，不是圆形\n  // background: linear-gradient(135deg, #ff6b35 0%, #f7931e 100%); // 橙色渐变背景\n  flex-shrink: 0;\n  position: relative;\n  overflow: hidden;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-shadow: @box-shadow-sm;\n\n  .mobile({\n    width: 3rem; // 36px\n    height: 3rem; // 36px\n  });\n  .desktop({\n    width: 5rem; \n    height: 5rem; \n    border-radius: 1rem;\n  });\n}\n\n.avatarImage {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  border-radius: @border-radius-md;\n}\n\n.avatarPlaceholder {\n  width: 100%;\n  height: 100%;\n  // 占位符样式已在 .avatar 的背景中定义\n}\n\n.userText {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: @spacing-xs;\n  font-size: @font-size-xs;\n}\n\n.gameNameRow {\n  display: none;\n  \n  .desktop({\n    display: block;\n    font-size: @font-size-md;\n    font-weight: 500;\n    color: @text-color;\n    margin-bottom: @spacing-xs;\n  });\n}\n\n.loginRow {\n  .flex-start();\n  align-items: center;\n  gap: @spacing-xs;\n  width: 100%;\n}\n\n.greetingText {\n  color: @text-color; // 正常字体颜色\n  font-size: @font-size-sm;\n\n  .mobile({\n    font-size: 0.4625rem;\n  });\n}\n\n.loginPromptText {\n  color: @primary-color; // 蓝色字体\n  font-size: @font-size-sm;\n  cursor: pointer;\n  transition: opacity 0.2s ease;\n\n  &:hover {\n    opacity: 0.8;\n  }\n\n  &:active {\n    opacity: 0.6;\n  }\n\n  .mobile({\n    font-size: @font-size-xs;\n  });\n}\n\n.arrowIcon {\n  display: inline-block;\n  width: auto;\n  height: 1em;\n  vertical-align: middle;\n  margin-left: @spacing-xs;\n  cursor: pointer;\n  transition: opacity 0.2s ease;\n\n  &:hover {\n    opacity: 0.8;\n  }\n\n  &:active {\n    opacity: 0.6;\n  }\n\n  .mobile({\n    height: 1rem; // 16px\n    margin-left: 0.25rem; // 4px\n  });\n}\n\n.characterInfo {\n  .flex-start();\n  align-items: center;\n  gap: @spacing-xs;\n  flex-wrap: wrap;\n  font-size: @font-size-sm;\n}\n\n.characterNameLink {\n  color: @primary-color;\n  // font-size: @font-size-xs;\n  cursor: pointer;\n  transition: color 0.2s ease;\n\n  &:hover {\n    color: darken(@primary-color, 10%);\n  }\n\n}\n\n.gameServerText {\n  color: @text-color-secondary;\n  font-size: @font-size-sm;\n\n  .mobile({\n    font-size: @font-size-sm;\n  });\n}\n\n.switchServerButton {\n  .button-reset();\n  .flex-center();\n  padding: 0.125rem @spacing-xs; // 2px\n  background: transparent;\n  border: none;\n  color: @primary-color;\n  cursor: pointer;\n  transition: opacity 0.2s ease;\n\n  &:hover {\n    opacity: 0.8;\n  }\n\n  &:active {\n    opacity: 0.6;\n  }\n\n  .mobile({\n    padding: 0.0625rem 0.25rem; // 1px 4px\n  });\n}\n\n.container {\n  position: relative;\n  z-index: 2;\n  display: flex;\n  align-items: center;\n  margin: 0 auto;\n  gap: @spacing-lg;\n\n  .mobile({\n    padding: 0 @spacing-sm;\n    justify-content: space-between;\n  });\n  .tablet({\n    padding: @spacing-md 1.25rem;\n    justify-content: space-between;\n    width: 100%;\n    box-sizing: border-box;\n  });\n\n  .desktop({\n    justify-content: space-between;\n    padding: @spacing-lg 1rem;\n    width: 100%;\n  });\n\n}\n\n.logoSection {\n  .flex-start();\n  align-items: center;\n  flex-shrink: 0;\n}\n\n.logo {\n  text-decoration: none;\n  display: flex;\n  align-items: center;\n  gap: @spacing-xs;\n\n  .desktop({\n    gap: @spacing-sm;\n  });\n}\n\n.logoIcon {\n  height: 2.25rem;\n  width: auto;\n  object-fit: contain;\n  display: block;\n  flex-shrink: 0;\n\n  .mobile({\n    height: 1.875rem;\n  });\n\n  .tablet({\n    height: 2.25rem;\n  });\n\n  .desktop({\n    height: 4rem;\n  });\n}\n\n.logoTextImg {\n  height: 1.5rem;\n  width: auto;\n  max-width: 100%;\n  object-fit: contain;\n  display: block;\n  flex-shrink: 0;\n\n  .mobile({\n    width: auto;\n    max-width: 100%;\n    height: auto;\n    max-height: 1rem;\n    align-self: flex-start;\n  });\n\n  .tablet({\n    width: auto;\n    max-width: 100%;\n    height: auto;\n    max-height: 1.25rem;\n    align-self: flex-start;\n  });\n\n  .desktop({\n    width: auto;\n    height: 2rem;\n    max-height: none;\n    margin-top: 0;\n    align-self: center;\n  });\n}\n\n.nav {\n  .flex-start();\n  gap: @spacing-lg;\n\n  // 平板和手机端都使用显隐菜单\n  @media (max-width: 1023px) {\n    position: fixed;\n    top: 3.75rem; // 60px\n    left: 0;\n    right: 0;\n    flex-direction: column;\n    background: @white;\n    box-shadow: @box-shadow-md;\n    transform: translateX(-100%);\n    transition: transform 0.3s ease;\n    gap: 0;\n    z-index: @z-index-dropdown;\n    padding: @spacing-xs 0;\n\n    &.navOpen {\n      transform: translateX(0);\n    }\n  }\n  // 电脑端隐藏\n  .desktop({\n    display: none;\n  });\n}\n\n.navItem {\n  color: @text-color;\n  text-decoration: none;\n  font-size: @font-size-md;\n  font-family: @font-family-display;\n  transition: color 0.3s ease;\n  .flex-start();\n  align-items: center;\n  gap: @spacing-sm;\n  background: none;\n  border: none;\n  cursor: pointer;\n  font-family: inherit;\n  padding: 0;\n\n  &:hover {\n    color: @primary-color;\n  }\n\n  .mobile({\n    text-align: center;\n    margin: 0 auto;\n    border-bottom: 1px solid @border-color;\n    width: 70%;\n    padding: @spacing-md @spacing-lg;\n    .touch-friendly();\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    font-size: @font-size-sm;\n    gap: @spacing-md;\n  });\n  .tablet({\n    text-align: center;\n    margin: 0 auto;\n    border-bottom: 1px solid @border-color;\n    width: 70%;\n    padding: @spacing-md @spacing-lg;\n    .touch-friendly();\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    font-size: @font-size-sm;\n    gap: @spacing-md;\n  });\n\n  &:last-child {\n    border-bottom: none;\n  }\n}\n\n.navIcon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  width: 1.25rem; // 20px\n  height: 1.25rem; // 20px\n  color: inherit;\n\n  .mobile({\n    width: 1.25rem; // 20px\n    height: 1.25rem; // 20px\n  });\n}\n\n.navText {\n  flex: 0 0 auto;\n  font-family: @font-family-display;\n}\n\n.actions {\n  .flex-start();\n  gap: @spacing-sm;\n  align-items: center;\n\n  .mobile({\n    gap: @spacing-xs;\n  });\n}\n\n// PC端导航\n@header-nav-select-image: '../../assets/img2/pay_top_title_select.png';\n\n// 用户下拉（设计稿：深棕底 + 金褐描边/分割线）\n@header-user-dropdown-bg: #3c302a;\n@header-user-dropdown-border: #9c8466;\n@header-user-dropdown-radius: 0.75rem;\n@header-home-dropdown-bg: @header-user-dropdown-bg;\n@header-home-dropdown-border: @header-user-dropdown-border;\n\n.desktopNav {\n  display: none;\n  .flex-start();\n  gap: @spacing-md;\n  align-items: center;\n  flex: 1;\n  justify-content: flex-end;\n  padding-right: @spacing-xl;\n\n  .desktop({\n    display: flex;\n    justify-content: flex-start;\n    margin-left: @spacing-lg;\n  });\n  .tablet({\n    display: flex;\n    justify-content: flex-start;\n    margin-left: @spacing-lg;\n    padding-right: @spacing-md;\n  });\n  .mobile({\n    display: none;\n  });\n}\n\n.desktopNavItem {\n  .button-reset();\n  color: rgba(255, 255, 255, 0.82);\n  font-family: @font-family-display;\n  font-size: @font-size-md;\n  text-decoration: none;\n  padding: 0;\n  cursor: pointer;\n  transition: color 0.3s ease;\n  position: relative;\n  display: inline-block;\n  font-weight: bold;\n  font-size: @font-size-lg;\n  .mobile({\n    display: none;\n  });\n\n  &:hover {\n    color: @primary-color;\n  }\n\n  &.desktopNavItemPlatform {\n    color: #ff6c00;\n    font-size: 1.7rem;\n    margin-right: @spacing-lg;\n\n    .tablet({\n      display: none;\n    });\n\n    .desktop({\n      display: none;\n    });\n\n    &:hover {\n      color: #ff6c00;\n      opacity: 0.9;\n    }\n  }\n\n  &.desktopNavItemTab {\n    &:hover {\n      color: rgba(255, 255, 255, 0.95);\n    }\n\n    &.desktopNavItemActive {\n      color: #feba34;\n\n      &:hover {\n        color: #feba34;\n        opacity: 0.92;\n      }\n\n      &::after {\n        content: '';\n        position: absolute;\n        bottom: -0.375rem;\n        left: 50%;\n        transform: translateX(-50%);\n        width: 3.5625rem;\n        height: 0.25rem;\n        background: url(@header-nav-select-image) no-repeat center / contain;\n      }\n    }\n  }\n}\n\n.desktopNavDivider {\n  width: 3px;\n  height: 1.125rem;\n  background: rgba(255, 255, 255, 0.35);\n  flex-shrink: 0;\n  margin: 0 @spacing-xs;\n  border-radius: 4px;\n}\n\n// PC端登录按钮\n.loginButton {\n  display: none;\n  .button-reset();\n  padding: @spacing-sm @spacing-lg;\n  background-color: #ff8f1d;\n  color: @white;\n  border-radius: 999px;\n  font-size: @font-size-md;\n  cursor: pointer;\n  transition: opacity 0.2s ease, background-color 0.2s ease;\n\n\n  &:hover {\n    opacity: 0.9;\n  }\n\n  &:active {\n    opacity: 0.8;\n  }\n  .desktop({\n    display: block;\n  });\n\n  .tablet({\n    display: block;\n  });\n}\n\n// 用户下拉（PC / 平板 / 手机统一视觉）\n// inline-flex + stretch：触发器与菜单项共用同一列宽，避免子项宽度各算各的\n.userDropdown {\n  display: none;\n  position: relative;\n  min-width: 0;\n  flex-direction: column;\n  align-items: stretch;\n\n  .tablet({\n    display: inline-flex;\n    min-width: 12rem;\n    max-width: 18rem;\n  });\n\n  .desktop({\n    display: inline-flex;\n    min-width: 14rem;\n    max-width: 20rem;\n  });\n}\n\n.userDropdownProductsMobile {\n  .mobile({\n    display: inline-flex;\n    position: relative;\n    max-width: 42vw;\n    min-width: 0;\n  });\n}\n\n.userDropdownHomeMobile {\n  .mobile({\n    display: inline-flex;\n    position: relative;\n    max-width: 48vw;\n    min-width: 0;\n  });\n}\n\n.userDropdownOpen .userDropdownTrigger {\n  border-radius: @header-user-dropdown-radius @header-user-dropdown-radius 0 0;\n  border-bottom-color: transparent;\n}\n\n.userDropdownTrigger {\n  .button-reset();\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.375rem;\n  width: 100%;\n  box-sizing: border-box;\n  padding: 0.625rem 0.75rem;\n  background-color: @header-user-dropdown-bg;\n  border: 1px solid @header-user-dropdown-border;\n  border-radius: @header-user-dropdown-radius;\n  cursor: pointer;\n  transition: background-color 0.2s ease;\n\n  &:hover {\n    background-color: lighten(@header-user-dropdown-bg, 4%);\n  }\n\n  .mobile({\n    padding: 0.5rem 0.625rem;\n    gap: 0.25rem;\n  });\n}\n\n.userEmail {\n  flex: 1;\n  min-width: 0;\n  font-family: @font-family-sans;\n  font-size: @font-size-sm;\n  font-weight: 700;\n  color: @white;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  text-align: left;\n\n  .mobile({\n    font-size: @font-size-xxs;\n  });\n\n  .desktop({\n    font-size: @font-size-md;\n  });\n}\n\n.chevronIcon {\n  flex-shrink: 0;\n  width: 0.875rem;\n  height: 0.875rem;\n  transition: transform 0.2s ease;\n\n  .mobile({\n    width: 0.75rem;\n    height: 0.75rem;\n  });\n}\n\n.chevronIconOpen {\n  transform: rotate(180deg);\n}\n\n// 下拉菜单共用外观（定位由 Docked / Portal 分担）\n.userDropdownMenu {\n  margin-top: 0;\n  padding: 0;\n  box-sizing: border-box;\n  background-color: @header-user-dropdown-bg;\n  border: 1px solid @header-user-dropdown-border;\n  border-top: none;\n  border-radius: 0 0 @header-user-dropdown-radius @header-user-dropdown-radius;\n  box-shadow: none;\n  overflow: hidden;\n}\n\n// 平板及以上：菜单仍在 .userDropdown 内绝对定位，宽度跟触发器\n.userDropdownMenuDocked {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  width: 100%;\n  min-width: 100%;\n  z-index: @z-index-dropdown + 1;\n}\n\n// 手机端挂到 body；禁止 width/min-width:100%（否则会按视口撑满）\n.userDropdownMenuPortal {\n  position: fixed;\n  z-index: @z-index-dropdown + 2;\n  min-width: 0;\n  max-width: none;\n}\n\n.userDropdownDivider {\n  height: 1px;\n  margin: 0;\n  background-color: @header-user-dropdown-border;\n}\n\n.userDropdownItem {\n  .button-reset();\n  display: block;\n  width: 100%;\n  box-sizing: border-box;\n  padding: 0.625rem 0.75rem;\n  text-align: center;\n  font-family: @font-family-sans;\n  font-size: @font-size-sm;\n  font-weight: 700;\n  color: @white;\n  cursor: pointer;\n  transition: background-color 0.2s ease;\n\n  &:hover {\n    background-color: lighten(@header-user-dropdown-bg, 6%);\n  }\n\n  &:active {\n    background-color: lighten(@header-user-dropdown-bg, 10%);\n  }\n\n  .mobile({\n    padding: 0.5rem 0.625rem;\n    font-size: @font-size-xs;\n  });\n}\n\n.logoTextGroup {\n  display: inline-flex;\n  flex-direction: column;\n  align-items: flex-start;\n  max-width: 100%;\n  min-width: 0;\n  vertical-align: middle;\n\n  .desktop({\n    flex-direction: row;\n    align-items: center;\n    gap: 0.625rem;\n  });\n}\n\n.logoSubtitle {\n  display: none;\n  box-sizing: border-box;\n  width: 100%;\n  margin-top: 0.125rem;\n  color: #fa5900;\n  font-family: \"JingNan BoBo Hei\";\n  white-space: normal;\n  overflow-wrap: break-word;\n  word-break: normal;\n  text-align: left;\n  line-height: 1.15;\n\n  .mobile({\n    display: block;\n    font-size: 0.725rem;\n    font-weight: 700;\n  });\n\n  .tablet({\n    display: block;\n    font-size: @font-size-md;\n    font-weight: 700;\n  });\n\n  .desktop({\n    display: block;\n    width: auto;\n    margin-top: 0;\n    margin-left: 1rem;\n    font-size: 2rem;\n    font-weight: 700;\n    line-height: 1.2;\n    white-space: nowrap;\n  });\n}\n\n@header-home-guest-bg: #1c1611;\n@header-home-guest-orange: #ff8a16;\n\n.headerHomeMobileDark {\n  background-color: #2c2c2c;\n  \n  .mobileHomeNav {\n    .mobile({\n      justify-content: flex-start;\n      flex: 1 1 auto;\n      min-width: 0;\n      gap: 0.625rem;\n    });\n\n    .tablet({\n      justify-content: flex-start;\n      flex: 1 1 auto;\n      min-width: 0;\n      gap: 0.625rem;\n    });\n\n    .desktop({\n      justify-content: flex-start;\n      flex: 1 1 auto;\n      min-width: 0;\n      gap: 0.75rem;\n    });\n  }\n\n  .mobileHomeNavItemActive {\n    .mobile({\n      color: @header-home-guest-orange;\n    });\n\n    .tablet({\n      color: @header-home-guest-orange;\n    });\n\n    .desktop({\n      color: @header-home-guest-orange;\n    });\n  }\n\n  .mobileHomeNavDivider {\n    .mobile({\n      background: rgba(255, 255, 255, 0.35);\n    });\n\n    .tablet({\n      background: rgba(255, 255, 255, 0.35);\n    });\n\n    .desktop({\n      background: rgba(255, 255, 255, 0.35);\n    });\n  }\n\n\n  .actions {\n    .mobile({\n      margin-left: auto;\n      flex-shrink: 0;\n    });\n\n    .tablet({\n      margin-left: auto;\n      flex-shrink: 0;\n    });\n\n    .desktop({\n      margin-left: auto;\n      flex-shrink: 0;\n    });\n  }\n\n  // ≤413px：缩小顶栏控件，避免 mobileHomeNav 与 userDropdown 重叠\n  .mobileNarrow({\n    .containerHomeMobileDark,\n    .containerHomeMobile {\n      gap: 0.375rem;\n    }\n\n    .logoIcon {\n      height: 1.625rem;\n    }\n\n    .logoTextImg {\n      max-height: 0.875rem;\n    }\n\n    .logoSubtitle {\n      font-size: 0.5rem;\n    }\n\n    .mobileHomeNav {\n      gap: 0.25rem;\n    }\n\n    .mobileHomeNavItem {\n      font-size: 0.625rem;\n    }\n\n    .mobileHomeNavDivider {\n      height: 0.625rem;\n    }\n\n    .userDropdownHomeMobile,\n    .userDropdownProductsMobile {\n      max-width: 32vw;\n    }\n\n    .userDropdownTrigger {\n      padding: 0.25rem 0.375rem;\n      gap: 0.125rem;\n    }\n\n    .userDropdownItem {\n      padding: 0.25rem 0.375rem;\n    }\n\n    .userEmail {\n      font-size: 0.5625rem;\n    }\n\n    .chevronIcon {\n      width: 0.75rem;\n      height: 0.75rem;\n    }\n  });\n}\n\n.headerHomeGuestMobile {\n  .loginButton {\n    .mobile({\n      display: block !important;\n      padding: 0.375rem 1.125rem;\n      font-size: @font-size-xs;\n      font-weight: 700;\n      background-color: @header-home-guest-orange;\n      border-radius: 999px;\n      white-space: nowrap;\n    });\n\n    .tablet({\n      display: block !important;\n      padding: 0.4375rem 1.25rem;\n      font-size: @font-size-sm;\n      font-weight: 700;\n      background-color: @header-home-guest-orange;\n      border-radius: 999px;\n      white-space: nowrap;\n    });\n  }\n}\n\n.containerHomeMobileDark {\n  .mobile({\n    gap: 0.625rem;\n    align-items: center;\n  });\n\n  .tablet({\n    gap: @spacing-md;\n    align-items: center;\n  });\n\n  .desktop({\n    gap: @spacing-md;\n    align-items: center;\n  });\n}\n\n.headerHomeMobile {\n  background-color: #000;\n\n  .mobileNarrow({\n    .containerHomeMobile {\n      gap: 0.375rem;\n    }\n\n    .logoIcon {\n      height: 1.625rem;\n    }\n\n    .logoTextImg {\n      max-height: 0.875rem;\n    }\n\n    .logoSubtitle {\n      font-size: 0.5rem;\n    }\n\n    .mobileHomeNav {\n      gap: 0.25rem;\n    }\n\n    .mobileHomeNavItem {\n      font-size: 0.625rem;\n    }\n\n    .mobileHomeNavDivider {\n      height: 0.625rem;\n    }\n\n    .userDropdownHomeMobile,\n    .userDropdownProductsMobile {\n      max-width: 32vw;\n    }\n\n    .userDropdownTrigger {\n      padding: 0.25rem 0.375rem;\n      gap: 0.125rem;\n    }\n\n    .userDropdownItem {\n      padding: 0.25rem 0.375rem;\n    }\n\n    .userEmail {\n      font-size: 0.5625rem;\n    }\n\n    .chevronIcon {\n      width: 0.75rem;\n      height: 0.75rem;\n    }\n  });\n}\n\n.containerHomeMobile {\n  .mobile({\n    gap: 1rem;\n  });\n\n  .tablet({\n    gap: @spacing-md;\n  });\n\n  .desktop({\n    gap: @spacing-md;\n  });\n}\n\n.mobileHomeNav {\n  display: none;\n\n  .mobile({\n    display: flex;\n    align-items: center;\n    justify-content: left;\n    gap: @spacing-sm;\n    flex: 1;\n    min-width: 0;\n  });\n}\n\n.mobileHomeNavItem {\n  .button-reset();\n  position: relative;\n  color: @white;\n  font-size: @font-size-xs;\n  font-weight: 700;\n  text-decoration: none;\n  white-space: nowrap;\n  cursor: pointer;\n  transition: opacity 0.2s ease, color 0.2s ease;\n\n  &:hover {\n    opacity: 0.85;\n  }\n}\n\n.mobileHomeNavItemActive {\n  color: #feba34;\n\n  &::after {\n    content: '';\n    position: absolute;\n    bottom: -0.25rem;\n    left: 50%;\n    transform: translateX(-50%);\n    width: 2.75rem;\n    height: 0.25rem;\n    background: url(@header-nav-select-image) no-repeat center / contain;\n    pointer-events: none;\n  }\n\n  .mobileNarrow({\n    &::after {\n      width: 2.25rem;\n      bottom: -0.1875rem;\n    }\n  });\n}\n\n.mobileHomeNavDivider {\n  width: 1px;\n  height: 0.875rem;\n  background: rgba(255, 255, 255, 0.35);\n  flex-shrink: 0;\n}\n\n.loginButtonMobileHome {\n  .mobile({\n    display: block !important;\n  });\n\n  .tablet({\n    display: block !important;\n  });\n}\n\n.menuButtonHomeHidden {\n  @media (max-width: 1023px) {\n    display: none !important;\n  }\n}\n\n.menuButton {\n  display: none;\n  .button-reset();\n  .touch-friendly();\n  .flex-center();\n  color: @white;\n  padding: @spacing-xs;\n\n  .mobile({\n    display: flex;\n  });\n\n  .desktop({\n    display: none;\n  });\n}\n\n","@import './variables.less';\n\n// 响应式 Mixins\n.mobile(@rules) {\n  @media (max-width: 767px) {\n    @rules();\n  }\n}\n\n.mobileNarrow(@rules) {\n  @media (max-width: 413px) {\n    @rules();\n  }\n}\n\n.tablet(@rules) {\n  @media (min-width: 768px) and (max-width: 1023px) {\n    @rules();\n  }\n}\n\n.desktop(@rules) {\n  @media (min-width: 1024px) {\n    @rules();\n  }\n}\n\n.tablet-up(@rules) {\n  @media (min-width: 768px) {\n    @rules();\n  }\n}\n\n// 紧凑 PC（1024~1728 宽）：首页 banner 缩小与垂直微调\n.homeCompactPc(@rules) {\n  @media (min-width: 1024px) and (max-width: 1728px) {\n    @rules();\n  }\n}\n\n.homeCompactPcShort(@rules) {\n  @media (min-width: 1024px) and (max-width: 1728px) and (max-height: 1000px) {\n    @rules();\n  }\n}\n\n// 宽屏 PC（>1728 宽）：首页 banner 放大\n.homeWidePc(@rules) {\n  @media (min-width: 1729px) {\n    @rules();\n  }\n}\n\n// 浏览器放大/缩小时：横向裁切装饰溢出，纵向允许滚动避免内容显示不全\n.zoomScrollablePage() {\n  overflow-x: hidden;\n  overflow-y: auto;\n}\n\n// Flexbox Mixins\n.flex-center() {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.flex-between() {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.flex-start() {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n}\n\n// 文本省略\n.text-ellipsis() {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.text-ellipsis-multi(@lines: 2) {\n  display: -webkit-box;\n  -webkit-line-clamp: @lines;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n// 清除浮动\n.clearfix() {\n  &::after {\n    content: '';\n    display: table;\n    clear: both;\n  }\n}\n\n// 按钮重置\n.button-reset() {\n  border: none;\n  background: none;\n  padding: 0;\n  margin: 0;\n  cursor: pointer;\n  outline: none;\n  font-family: inherit;\n}\n\n// 触摸友好\n.touch-friendly() {\n  min-height: 2.75rem; // 44px\n  min-width: 2.75rem; // 44px\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header": `slSYbgCh`,
	"loginBar": `VjeZst5L`,
	"loginBarHiddenOnDesktop": `z8MR9HQQ`,
	"loginBarProductsMobileOnly": `dG2Qxs0k`,
	"loginBarProductsMobileHidden": `a_eZ1XUE`,
	"loginBarHomeMobileHidden": `yb7OA2X7`,
	"loginContent": `BtEycIWT`,
	"userInfo": `Y4OQJmfp`,
	"avatar": `zHIhM57O`,
	"avatarImage": `OTNvIQ1p`,
	"avatarPlaceholder": `GDmL5IO3`,
	"userText": `sVB5c3uo`,
	"gameNameRow": `WfBlVulO`,
	"loginRow": `qN8X9qUM`,
	"greetingText": `o75QkgKG`,
	"loginPromptText": `d5JyeBW_`,
	"arrowIcon": `p7ZdYuU7`,
	"characterInfo": `iJmvZ14p`,
	"characterNameLink": `SGn_HB4s`,
	"gameServerText": `GwNgdG1L`,
	"switchServerButton": `sLKWM0Wj`,
	"container": `UA1ikLgE`,
	"logoSection": `_fyIi7KJ`,
	"logo": `sbCrta3X`,
	"logoIcon": `bPFeSkuu`,
	"logoTextImg": `aYCUJo6Z`,
	"nav": `YEXthgKT`,
	"navOpen": `Mg_ORDaH`,
	"navItem": `NRbCIQNp`,
	"navIcon": `o_dTFhV5`,
	"navText": `s4NCMenQ`,
	"actions": `WxmOruAL`,
	"desktopNav": `TWzNkum5`,
	"desktopNavItem": `Cfpkiz5W`,
	"desktopNavItemPlatform": `x1_I8CNw`,
	"desktopNavItemTab": `_9tAt3YC`,
	"desktopNavItemActive": `BY_mTe0r`,
	"desktopNavDivider": `UELox73u`,
	"loginButton": `YxQQ0tvE`,
	"userDropdown": `DrhfkESi`,
	"userDropdownProductsMobile": `ACcRgdGU`,
	"userDropdownHomeMobile": `BZjvUcHB`,
	"userDropdownOpen": `onBSJRgN`,
	"userDropdownTrigger": `amrPemvn`,
	"userEmail": `FX3bc5nT`,
	"chevronIcon": `DFFBVVPO`,
	"chevronIconOpen": `LnJ91sL2`,
	"userDropdownMenu": `gr1jL_46`,
	"userDropdownMenuDocked": `ks3Nw2XX`,
	"userDropdownMenuPortal": `eTBjKnGi`,
	"userDropdownDivider": `NNNXQaBb`,
	"userDropdownItem": `DB7hJh15`,
	"logoTextGroup": `ct51z5xU`,
	"logoSubtitle": `SaCm9NPx`,
	"headerHomeMobileDark": `jMVNYpxK`,
	"mobileHomeNav": `bgBpjEza`,
	"mobileHomeNavItemActive": `o6H1hQYt`,
	"mobileHomeNavDivider": `ucMM2ewT`,
	"containerHomeMobileDark": `EI64mGw6`,
	"containerHomeMobile": `tflBBnun`,
	"mobileHomeNavItem": `TpiKZ7KT`,
	"headerHomeGuestMobile": `eEHixaFV`,
	"headerHomeMobile": `FjAMRuJf`,
	"loginButtonMobileHome": `WcW8I6HY`,
	"menuButtonHomeHidden": `kcKlUkRc`,
	"menuButton": `FmYnbzty`
};
export default ___CSS_LOADER_EXPORT___;
